export default "__VITE_ASSET__b51da1d4__"